import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { DEFAULT_LOCALE } from "@/config/site";
import { I18nProvider } from "@/i18n/I18nProvider";
import { WasOKLanding } from "@/landing/WasOKLanding";
import { AdvertisingPage } from "@/pages/AdvertisingPage";
import { FaqPage } from "@/pages/FaqPage";
import { LicensesPage } from "@/pages/LicensesPage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { PrivacyPolicyPage } from "@/pages/PrivacyPolicyPage";
import { SupportPage } from "@/pages/SupportPage";
import { TermsOfServicePage } from "@/pages/TermsOfServicePage";
import { LocaleLayout } from "@/routes/LocaleLayout";
import { ScrollToTop } from "@/routes/ScrollToTop";

const LEGACY_PATHS = [
  "privacy-policy",
  "terms-of-service",
  "faq",
  "support",
  "licenses",
  "advertising",
] as const;

export function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route
            path="/"
            element={<Navigate to={`/${DEFAULT_LOCALE}`} replace />}
          />

          {/* Retired: app is in production */}
          <Route
            path="/beta"
            element={<Navigate to={`/${DEFAULT_LOCALE}`} replace />}
          />

          {LEGACY_PATHS.map((segment) => (
            <Route
              key={segment}
              path={`/${segment}`}
              element={
                <Navigate to={`/${DEFAULT_LOCALE}/${segment}`} replace />
              }
            />
          ))}

          <Route path="/:locale" element={<LocaleLayout />}>
            <Route index element={<WasOKLanding />} />
            <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="terms-of-service" element={<TermsOfServicePage />} />
            <Route path="faq" element={<FaqPage />} />
            <Route path="support" element={<SupportPage />} />
            <Route path="licenses" element={<LicensesPage />} />
            <Route path="advertising" element={<AdvertisingPage />} />
            <Route path="beta" element={<Navigate to=".." replace />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </I18nProvider>
  );
}
